import { concatStyleSets, IStyle } from '@fluentui/react';

import { IH2OTheme } from '../../models/components.models';
import { FontSizes, FontWeights, Sizes } from '../../themes/styles';
import { CommonStyles } from '../../themes/themes';

export interface IWidgetPanelStyles {
  root: IStyle;
  header: IStyle;
  titleAndDescription: IStyle;
  title: IStyle;
  description: IStyle;
  controls: IStyle;
  link: IStyle;
  button: IStyle;
  actions: IStyle;
  body: IStyle;
  leftLabel: IStyle;
  leftLabelText: IStyle;
  bottomLabel: IStyle;
}

export interface IWidgetPanelClassNames {
  root: string;
  header: string;
  titleAndDescription: string;
  title: string;
  description: string;
  controls: string;
  link: string;
  button: string;
  actions: string;
  body: string;
  leftLabel: string;
  leftLabelText: string;
  bottomLabel: string;
}

export const widgetPanelStylesDefault = (theme: IH2OTheme): Partial<IWidgetPanelStyles> => ({
  root: {
    height: '100%',
    borderRadius: Sizes.borderRadius,
    backgroundColor: theme.palette?.white,
    display: 'flex',
    flexDirection: 'column',
    padding: '24px 8px 24px 8px',
    '&.has-left-label': {
      paddingLeft: 24,
      '.h2o-WidgetPanel-header': {
        paddingLeft: 0,
      },
      '.h2o-WidgetPanel-body': {
        borderLeft: '16px solid transparent',
      },
    },
    '&.has-bottom-label': {
      '.h2o-WidgetPanel-body': {
        borderBottom: '20px solid transparent',
      },
    },
  },
  header: {
    padding: '0 16px 12px 16px',
    display: 'flex',
  },
  titleAndDescription: { flex: 1 },
  title: { fontSize: FontSizes.large, fontWeight: FontWeights.semiBold },
  description: { color: theme.semanticColors?.textSecondary, marginTop: 8 },
  controls: { display: 'flex' },
  link: {
    lineHeight: 20,
  },
  button: { marginLeft: 20 },
  actions: {},
  body: { flex: 1, position: 'relative', minHeight: 0 },
  leftLabel: {
    position: 'absolute',
    height: '100%',
    top: 0,
    left: -20,
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  leftLabelText: {
    transformOrigin: 'bottom',
    transform: 'rotate(270deg)',
    color: theme.semanticColors?.textSecondary,
  },
  bottomLabel: {
    position: 'absolute',
    width: '100%',
    left: 0,
    bottom: -20,
    textAlign: 'center',
    color: theme.semanticColors?.textSecondary,
  },
});

export const widgetPanelStylesCardList: Partial<IWidgetPanelStyles> = {
  root: {
    paddingBottom: 16,
  },
  body: {
    paddingLeft: 8,
    paddingRight: 8,
  },
};

export const widgetPanelStylesInfo = (theme: IH2OTheme): Partial<IWidgetPanelStyles> => ({
  root: {
    border: `1px solid ${theme.semanticColors?.inputBorder}`,
    paddingBottom: 8,
  },
  title: {
    fontSize: FontSizes.textPrimary,
  },
});

export const widgetPanelStylesNoBG: Partial<IWidgetPanelStyles> = {
  root: {
    background: 'transparent',
    padding: 0,
    borderRadius: 'none',
  },
  header: {
    padding: 0,
    paddingBottom: Sizes.padding,
  },
  title: {
    fontSize: FontSizes.small,
    lineHeight: '20px',
  },
  controls: { ...CommonStyles.flexCenterVertically },
};

export const widgetPanelStylesNoBGWhiteBody = (theme: IH2OTheme): Partial<IWidgetPanelStyles> =>
  concatStyleSets(widgetPanelStylesNoBG, {
    body: {
      backgroundColor: theme.semanticColors?.contentBackground,
      paddingTop: `${Sizes.padding / 2}px`,
      paddingLeft: Sizes.padding,
      paddingRight: Sizes.padding,
      borderRadius: Sizes.borderRadius,
    },
  });
